import { useCallback, useEffect, useState } from "react";
import { WrappedFieldProps } from "redux-form";

import { FormMultiSelectDropdown } from "@seneca/senekit";
import { Option } from "@seneca/senekit/out/components/controls/MultiSelectDropdown/types";

import useSubjectDropdownOptions from "./hooks/useSubjectDropdownOptions";

type Props = WrappedFieldProps;

export default function SubjectDropdown(props: Props) {
  const {
    input: { name, onChange },
    meta: { error, submitFailed }
  } = props;

  const [selectedSubjects, setSelectedSubjects] = useState<Option[]>([]);

  const { dropdownOptions, defaultSubjects, defaultSubjectOptions, isLoading } =
    useSubjectDropdownOptions();

  useEffect(() => {
    if (defaultSubjects && defaultSubjectOptions) {
      setSelectedSubjects(defaultSubjectOptions);
      onChange(defaultSubjects);
    }
  }, [defaultSubjects, defaultSubjectOptions, onChange]);

  const handleChange = useCallback(
    (options: Option[]) => {
      setSelectedSubjects(options);
      onChange(options.map(({ label }) => label));
    },
    [onChange, setSelectedSubjects]
  );

  return (
    <FormMultiSelectDropdown
      name={name}
      label="Subjects taught"
      value={selectedSubjects}
      onChange={handleChange as any}
      error={error}
      showError={!!error || submitFailed}
      options={dropdownOptions}
      maxMultiValueLabels={2}
      isLoading={isLoading}
    />
  );
}
